import { Component } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-unauthorised',
  templateUrl: './unauthorised.html',
  styleUrl: './unauthorised.scss',
  imports: [
    NgOptimizedImage,
    TranslocoPipe
  ]
})
export class Unauthorised {
  public jcbPortalUrl = environment.jcbPortal;
}
